/*! nukumo — ページ内リンクの移動位置をヘッダーに合わせてぴったりにする */
(function () {
  'use strict';
  if (window.__nkAnchor) return;
  window.__nkAnchor = true;

  /* ページ内リンク（「セットと価格を見る」など）で、移動先をヘッダーのすぐ下にぴったり合わせる */
  function anchorEl(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    /* スマホでは「セットと価格を見る」で商品画像ではなく、商品名・価格・まとめ買いから見せる */
    if (window.innerWidth < 990) {
      var m = el.querySelector('[data-nk-anchor-m], .gb-buy__info');
      if (m) return m;
    }
    return el;
  }
  function headerWrap() { return document.querySelector('[data-gb-header]'); }
  function anchorTop(el) {
    var gap = el.hasAttribute('data-nk-anchor-gap') ? parseInt(el.getAttribute('data-nk-anchor-gap'), 10) || 0
      : (el.matches('.gb-buy__info') ? 16 : 0);
    return el.getBoundingClientRect().top + window.pageYOffset - gap;
  }
  function jumpTo(el, smooth) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) smooth = false;
    var wrap = headerWrap();
    var hh = wrap ? wrap.offsetHeight : 0;
    var hides = !!wrap && wrap.getAttribute('data-autohide') !== 'false';
    var top = anchorTop(el);
    /* 下に進むとヘッダーは自動で隠れるので、その分の余白は取らない。上に戻るときはヘッダーの高さ分ずらす */
    var down = hides && top > window.pageYOffset + 8 && top > hh * 2;
    var off = down ? 0 : hh;
    var y = Math.max(0, Math.round(top - off));
    var root = document.documentElement;
    var startY = window.pageYOffset;
    root.classList.add('nk-jumping');
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
    var done = false;
    var fix = function () {
      if (done) return; done = true;
      if (hides) wrap.classList.toggle('is-hidden', down);
      var y2 = Math.max(0, Math.round(anchorTop(el) - off));
      var cur = window.pageYOffset;
      /* 途中で画像の読み込みなどで位置がずれた分を直す（ユーザーが自分でスクロールした場合はそのまま） */
      if ((Math.abs(cur - y) < 240 || Math.abs(cur - startY) < 2) && Math.abs(y2 - cur) > 1) window.scrollTo({ top: y2, behavior: 'auto' });
      setTimeout(function () { root.classList.remove('nk-jumping'); }, 50);
    };
    if (smooth && 'onscrollend' in window) window.addEventListener('scrollend', fix, { once: true });
    setTimeout(fix, smooth ? 1200 : 80);
  }
  function initAnchors() {
    window.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || a.classList.contains('skip-link')) return;
      var href = a.getAttribute('href');
      var i = href.indexOf('#');
      if (i > 0 && a.pathname !== window.location.pathname) return;
      var id = decodeURIComponent(href.slice(i + 1));
      if (!id) return;
      var el = anchorEl(id);
      if (!el) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      jumpTo(el, true);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    }, true);
    /* 別のページから「…#buy」付きのリンクで来たとき */
    if (window.location.hash.length > 1) {
      var go = function () {
        var el = anchorEl(decodeURIComponent(window.location.hash.slice(1)));
        if (el) jumpTo(el, false);
      };
      if (document.readyState === 'complete') setTimeout(go, 0); else window.addEventListener('load', function () { setTimeout(go, 0); }, { once: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAnchors); else initAnchors();
})();
